export default "__VITE_ASSET__CeP9uX2s__"